export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fb11454d4662bdbe8a23904139486c977a2e6a1d1&name=fetchTypeahead!'